export default {
    currentStep: 0,
    form: {
        b2BVenderId: null,
        venderId: null,
        categoriesStr: '',
        firstCid: null,
        firstCidName: '',
        secondCid: null,
        secondCidName: '',
        categoryId: null,
        categoryIdName: '',
        multiCategoryId: null,
        advWords: '',
        skuList: [],
        isPublic: true,
        images: [],
        spuId: null,
        spuName: '',
        companyName: '',
        spuStatus: null, //商品有效状态 1：有效 -1：无效
        spuState: null, //商品上下架状态 1：在售 0：待售
        auditState: '',
        skuWareVoList: [],
        attrMap: {}
    },
    selectedList: [],
    combination: []
}


// WEBPACK FOOTER //
// ./src/store/create-ware/state.js